import React from 'react';

import styled from 'styled-components';
import { Link } from 'gatsby';

import * as Yup from 'yup';
import { withFormik } from 'formik';
import swal from 'sweetalert';
import addToMailchimp from 'gatsby-plugin-mailchimp';

import { Heading, Subtitle, InputGroup, Button } from '../elements';

const Section = styled.footer`
  background-color: ${(props) => props.theme.backgroundLightAccent};
  label {
    line-height: 30px;
  }
`;

const SubscribeForm = (props) => {
  const {
    data,
    values,
    touched,
    errors,
    isSubmitting,
    handleChange,
    handleBlur,
    handleSubmit,
  } = props;

  return (
    <Section className="section">
      <div className="container">
        <div className="columns is-vcentered">
          <div className="column is-5">
            <Heading size="is-4" className="is-uppercase pb-3" dark>
              {data.subscribeTitle}
            </Heading>
            <Subtitle dark>{data.subscribeDescription}</Subtitle>
          </div>
          <div className="column is-7">
            <form onSubmit={handleSubmit}>
              <div className="field is-grouped">
                <div className="control is-expanded">
                  <InputGroup
                    name="email"
                    className="is-medium"
                    placeholder="Enter your email address"
                    type="email"
                    value={values.email}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    errors={
                      errors.email && touched.email ? errors.email : undefined
                    }
                  />
                  <label className="is-size-6">
                    By signing up you thereby agree to our contact{' '}
                    <Link
                      className="has-text-orange"
                      to="/terms-and-conditions/"
                    >
                      terms and conditions.
                    </Link>
                  </label>
                </div>
                <p className="control">
                  <Button
                    disabled={isSubmitting}
                    type="submit"
                    className={`button is-primarye ${
                      isSubmitting && 'is-loading'
                    }`}
                  >
                    Submit
                  </Button>
                </p>
              </div>
            </form>
          </div>
        </div>
      </div>
    </Section>
  );
};

export default withFormik({
  mapPropsToValues: () => ({
    email: '',
  }),
  validationSchema: Yup.object().shape({
    email: Yup.string()
      .email('Invalid email address')
      .required('Email is required!'),
  }),
  handleSubmit: (values, { setSubmitting, resetForm }) => {
    addToMailchimp(values.email)
      .then(() => {
        swal('Subscribed successfully, thank you!');
        setSubmitting(false);
        resetForm();
      })
      .catch(() => {
        swal('Already registered', 'error');
        setSubmitting(false);
      });
  },
  displayName: 'SubscribeForm', // helps with React DevTools
})(SubscribeForm);
